import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const CANCEL_SUBSCRIPTION_FOR_USER =
  "SUBSCRIPTION:CANCEL_SUBSCRIPTION_FOR_USER";

export interface CancelSubscriptionForUser extends Action {
  type: typeof CANCEL_SUBSCRIPTION_FOR_USER;
  organization: OrganizationKeyName;
  subscriptionId: string;
  userId: number;
  cancelImmediately: boolean;
}

export const cancelSubscriptionForUser = (
  organization: OrganizationKeyName,
  userId: number,
  subscriptionId: string,
  cancelImmediately: boolean
): CancelSubscriptionForUser => ({
  type: CANCEL_SUBSCRIPTION_FOR_USER,
  organization,
  subscriptionId,
  userId,
  cancelImmediately,
});
